import Header from "../components/Sections/Header";

export default function Home() {
  return (
      <>
          <Header />
  
      </>
  )
  
}
